import type { HighlightRanges } from '@nozbe/microfuzz';
import { Highlight } from '@nozbe/microfuzz/react';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { SearchFriend } from '@/hooks/search/use-search-friends';
import SearchListItem from './search-list-item';
export default function SearchFriendResultItem({
  FriendID,
  FriendHeadImg,
  FriendNickName,
  RemarkName,
  FuzzySearch,
}: SearchFriend) {
  const { t } = useTranslation();

  const description = useMemo(() => {
    if (!FuzzySearch || !FuzzySearch.highlightRanges) {
      return null;
    }
    const tags = FuzzySearch?.highlightRanges
      ?.filter(({ key }) => key === 'Tags.TagName')
      .map(
        ({ indices, value }) =>
          value && (
            <Highlight
              style={{}}
              className='text-primary '
              key={FriendID + value}
              text={value}
              ranges={indices as HighlightRanges}
            />
          ),
      );
    if (!tags || tags.length === 0) {
      return null;
    }
    return (
      <>
        {t('common.tag')}:{' '}
        {tags.map((item, index) =>
          index < tags.length - 1
            ? [<Fragment key={index * 2}>{item}</Fragment>, <span key={index * 2 + 1}>, </span>]
            : [<Fragment key={index * 2}>{item}</Fragment>],
        )}
      </>
    );
  }, [FuzzySearch]);

  const highlight =
    FuzzySearch?.highlightRanges?.find(({ key }) => key === 'RemarkName' || key === 'FriendNickName')?.indices ||
    undefined;

  return (
    <SearchListItem
      avatarImageUrl={FriendHeadImg}
      title={RemarkName || FriendNickName}
      highlight={highlight as HighlightRanges}
      description={description}
    />
  );
}
